import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

export interface IHeaderSubtitleProps {
    subtitleText?: GenericLazyString | React.ReactElement;
}

const HeaderSubtitle = ({ subtitleText }: IHeaderSubtitleProps) => {
    let component = null;

    if (subtitleText) {
        component = (
            <div
                className="eds-l-pad-top-2 eds-text-bm eds-l-pad-top-2"
                data-testid="page-header-subtitle"
            >
                {subtitleText}
            </div>
        );
    }

    return component;
};

export default HeaderSubtitle;
